import { ContactResponse } from '@absis/core-plugins/dist/types/types/core-plugins-types';

export const CBContacts = {
  getContacts: (): Promise<Array<ContactResponse>> => {
    return Promise.reject(
      new Error('CBContacts is not supported for Desktop devices')
    );
  },
};
